<template>
    <div class="contacts-table">
        <snappy-table
            :endpoint="'vessels/' + vesselId + '/contacts'"
            :columns="['email', 'first_name', 'last_name', 'reason_for_unsubscribe', 'created_at', 'actions']"
            :template-methods="columnTemplates(timezone)"
            :templated-slot-names="['actions', 'reason_for_unsubscribe']"
            :headings="['Email', 'First Name', 'Last Name', 'Status', 'Created', 'Actions']"
            record-type="Contacts"
            table-class="subscribers-table"
        >
            <template #actions="{ row }">
                <div class="d-flex justify-content-end">
                    <a
                        class="btn btn-primary mx-2"
                        :href="createContactEditUrl(row.id)"
                        title="Edit Contact"
                        v-tooltip="'Edit Contact'"
                    >
                        <i class="fas fa-fw fa-edit"></i>
                    </a>

                    <button
                        class="btn btn-danger"
                        title="Delete"
                        v-tooltip="'Delete Contact'"
                        @click="onDeleteButtonClick($event, row)"
                    >
                        <i class="fas fa-fw fa-trash"></i>
                    </button>
                </div>
            </template>
            <template #reason_for_unsubscribe="{ row }">
                <div class="unsubscribe-reason" v-if="row.global_unsubscribe">
                    <span title="* contact is globally unsubscribed" class="label label-default"
                          v-if="row.reason_for_global_unsubscribe">{{ row.reason_for_global_unsubscribe }}</span>
                    <span title="* contact is globally unsubscribed" class="label label-default" v-else>Globally Unsubscribed</span>
                </div>
            </template>
        </snappy-table>
        <delete-records type="contacts"></delete-records>
        <delete-contact-modal v-if="deletedContact" :contact="deletedContact"
                              @close-modal="onCloseDeleteModal"></delete-contact-modal>
    </div>
</template>

<script>
import SnappyTable from '../../components/SnappyTable';
import DeleteRecords from '../../components/DeleteRecords';
import columnTemplates from '../../mixins/tables/columnTemplates';
import DeleteContactModal from '../contact/DeleteContactModal';

export default {
    name: 'contacts-table',
    components: {SnappyTable, DeleteRecords, DeleteContactModal},
    mixins: [columnTemplates],
    data() {
        return {
            deletedContact: null,
        };
    },
    methods: {
        createContactEditUrl(contactId) {
            return '/inventory/contacts/edit/?sk_token=' + btoa('contact_id=' + contactId);
        },

        onDeleteButtonClick(event, contact) {
            event.stopPropagation();
            this.deletedContact = contact;
        },
        onCloseDeleteModal() {
            this.deletedContact = null;
        }
    },
    props: {
        vesselId: {
            type: Number,
            required: true,
        },
        timezone: {
            type: String,
            required: true,
        },
    },
};
</script>
